import { Img } from "wmk-image";
import { TestimonyFields } from "../fragments/blockTestimonyFields";

export class Testimonial {
  title: string;
  image: Img;
  org: {
    name: string;
    logo: Img;
    url: string;
  };
  author: string;
  text: string;
  constructor(node: TestimonyFields) {
    const _node = { ...node };
    this.title = _node.title;
    this.image = new Img(_node.backgroundImage);
    this.org = {
      name: _node.organization,
      logo: new Img(_node.organizationLogo),
      url: _node.organizationUrl,
    };
    this.author = node.author;
    this.text = node.testimonial.testimonial;
  }
}
